import { createSlice } from "@reduxjs/toolkit";
import { apiCaller } from "../../api/apiCaller";
import { riskManagement } from "../../sharedfiles/EndpointConfig";
import { messageEnhancer, toaster } from "../../sharedfiles/helper";

// A framework-generated 400/404 has no `msg`, so apiCaller resolved `response`
// to undefined and the toast rendered empty - INT-11570.
const riskErrorText = (err) =>
    messageEnhancer(err?.response) ||
    err?.statusText ||
    (err?.statusCode ? `Request failed (${err.statusCode})` : "Something went wrong. Please try again.");

export const riskManagementSlice = createSlice({
    name: "riskManagement",
    initialState: {
        sameIps: [],
        sameIpUsers: [],
        fraudIpMacAdress: [],
        fraudIpMacByUsers: [],
        syndicateBetting: [],
        playerBets: [],
        arbitageData: [],
        dupeCids: [],
        isPrevUserResp: "",
        disableBtnRiskMgt: false,
        userIpData: {},
        prevPayload: {},
        isUserIpVisible: false,
        userSameIpVisible: false,

        //PAGINATION USER WITH SAMEIP//
        paginationFirstValSameIp: 1,
        paginationSecondValSameIp: 25,
        sameIpIsVisible: false,
        sameIpRecordShow: [1, 25],
        userPageOneValue: 1,
        userPageSecondValue: 25,
        userIsVisible: false,
        userRecordShow: [1, 25],
        openDialouge: false,
        //PAGINATION USER WITH SAMEIP//

        //PAGINATION USER WITH SAME MACIP//
        fraudMacIpPageOneValue: 1,
        fraudMacIpPageSecondValue: 25,
        fraudMacIpIsvisible: false,
        fraudMacIpRecordShow: [1, 25],
        userMacIpPageOneValue: 1,
        userMacIpSecondValue: 25,
        userMacIpIsVisible: false,
        userMacIpShowRecord: [1, 25],
        //PAGINATION USER WITH SAME MACIP//

        //PAGINATION SYNDICATE BETTING//
        syndicatePageOneVal: 1,
        syndicatePageSecondVal: 25,
        syndicateIsVisible: false,
        syndicateShowRecord: [1, 25],
        userSyndicatePageOneVal: 1,
        userSyndicateSecondVal: 25,
        userSyndicateIsVisible: false,
        userSyndictaeShowRecord: [1, 25],
        syndicateData: {},
        syndicatePayload: {},
        isUserLoading: false,
        //PAGINATION SYNDICATE BETTING//

        //PAGINTION ARBITAGE BETTING//
        arbitagePageOneVal: 1,
        arbitageSecondVal: 25,
        arbitageIsVisible: false,
        arbitageRecordShow: [1, 25],
        arbitageSearchDraft: "",
        //PAGINATION ARBITAGE BETTING//

        //V2 SYNDICATE BETTING//
        syndicateBettingV2: [],
        syndicateV2PageOneVal: 1,
        syndicateV2PageSecondVal: 25,
        syndicateV2IsVisible: false,
        syndicateV2ShowRecord: [1, 25],
        syndicateV2Payload: {},
        syndicateV2Data: {},
        isV2Loading: false,
        //V2 SYNDICATE BETTING//

        //SYNDICATE COMBINATIONS//
        syndicateCombinations: [],
        combinationsPageOneVal: 1,
        combinationsPageSecondVal: 25,
        combinationsIsVisible: false,
        combinationsShowRecord: [1, 25],
        //SYNDICATE COMBINATIONS//

        //SYNDICATE USER ANALYSIS//
        syndicateUserAnalysis: null,
        syndicateUserAnalysisOpen: false,
        isAnalysisLoading: false,
        //SYNDICATE USER ANALYSIS//

        //LATE BETS//
        lateBets: [],
        lateBetsPageOneVal: 1,
        lateBetsPageSecondVal: 25,
        lateBetsIsVisible: false,
        lateBetsShowRecord: [1, 25],
        isLateBetsLoading: false,
        //LATE BETS//

    },
    reducers: {
        setSameIps: (state, action) => {
            state.sameIps = action.payload
        },
        setSameIpUsers: (state, action) => {
            state.sameIpUsers = action.payload
        },
        setFraudIpMacAdress: (state, action) => {
            state.fraudIpMacAdress = action.payload
        },
        setFraudIpMacByUsers: (state, action) => {
            state.fraudIpMacByUsers = action.payload
        },
        setSyndicateBetting: (state, action) => {
            state.syndicateBetting = action.payload
        },
        setPlayerBets: (state, action) => {
            state.playerBets = action.payload
        },
        setArbitageData: (state, action) => {
            state.arbitageData = action.payload
        },
        setDupeCids: (state, action) => {
            state.dupeCids = action.payload
        },
        setIsPrevUserRespDupeCids: (state, action) => {
            state.isPrevUserResp = action.payload
        },
        setdisableBtnRiskMgt: (state, action) => {
            state.disableBtnRiskMgt = action.payload
        },
        setIsUserIpVisible: (state, action) => {
            state.isUserIpVisible = action.payload
        },
        setUserIpData: (state, action) => {
            state.userIpData = action.payload
        },
        setPrevPayload: (state, action) => {
            state.prevPayload = action.payload
        },
        setUserSameIpVisible: (state, action) => {
            state.userSameIpVisible = action.payload
        },


        //PAGINATION USER WITH SAMEIP//
        setPaginationFirstValSameIp: (state, action) => {
            state.paginationFirstValSameIp = action.payload
        },
        setPaginationSecondValSameIp: (state, action) => {
            state.paginationSecondValSameIp = action.payload
        },
        setSameIpIsVisible: (state, action) => {
            state.sameIpIsVisible = action.payload
        },
        setSameIpRecordShow: (state, action) => {
            state.sameIpRecordShow = action.payload
        },

        setUserPageOneValue: (state, action) => {
            state.userPageOneValue = action.payload
        },
        setUserPageSecondValue: (state, action) => {
            state.userPageSecondValue = action.payload
        },
        setUserIsVisible: (state, action) => {
            state.userIsVisible = action.payload
        },
        setUserRecordShow: (state, action) => {
            state.userRecordShow = action.payload
        },
        setOpenDialouge: (state, action) => {
            state.openDialouge = action.payload
        },
        //PAGINATION USER WITH SAMEIP//

        //PAGINATION USER WITH SAME MACIP//
        setFraudMacIpPageOneValue: (state, action) => {
            state.fraudMacIpPageOneValue = action.payload
        },
        setFraudMacIpPageSecondValue: (state, action) => {
            state.fraudMacIpPageSecondValue = action.payload
        },
        setFraudMacIpIsvisible: (state, action) => {
            state.fraudMacIpIsvisible = action.payload
        },
        setFraudMacIpRecordShow: (state, action) => {
            state.fraudMacIpRecordShow = action.payload
        },

        setUserMacIpPageOneValue: (state, action) => {
            state.userMacIpPageOneValue = action.payload
        },
        setUserMacIpSecondValue: (state, action) => {
            state.userMacIpSecondValue = action.payload
        },
        setUserMacIpIsVisible: (state, action) => {
            state.userMacIpIsVisible = action.payload
        },
        setUserMacIpShowRecord: (state, action) => {
            state.userMacIpShowRecord = action.payload
        },
        //PAGINATION USER WITH SAME MACIP//

        //PAGINATION SYNDICATE BETTING//
        setSyndicatePageOneVal: (state, action) => {
            state.syndicatePageOneVal = action.payload
        },
        setSyndicatePageSecondVal: (state, action) => {
            state.syndicatePageSecondVal = action.payload
        },
        setSyndicateIsVisible: (state, action) => {
            state.syndicateIsVisible = action.payload
        },
        setSyndicateShowRecord: (state, action) => {
            state.syndicateShowRecord = action.payload
        },

        setUserSyndicatePageOneVal: (state, action) => {
            state.userSyndicatePageOneVal = action.payload
        },
        setUserSyndicateSecondVal: (state, action) => {
            state.userSyndicateSecondVal = action.payload
        },
        setUserSyndicateIsVisible: (state, action) => {
            state.userSyndicateIsVisible = action.payload
        },
        setUserSyndictaeShowRecord: (state, action) => {
            state.userSyndictaeShowRecord = action.payload
        },
        setSyndicateData: (state, action) => {
            state.syndicateData = action.payload
        },
        setSyndicatePayload: (state, action) => {
            state.syndicatePayload = action.payload
        },
        setIsUserLoading: (state, action) => {
            state.isUserLoading = action.payload
        },

        //PAGINATION SYNDICATE BETTING//

        //PAGINATION ARBITAGE BETTING//
        setArbitagePageOneValue: (state, action) => {
            state.arbitagePageOneVal = action.payload
        },
        setArbitageSecondValue: (state, action) => {
            state.arbitageSecondVal = action.payload
        },
        setArbitageIsVisible: (state, action) => {
            state.arbitageIsVisible = action.payload
        },
        setArbitageShowRecord: (state, action) => {
            state.arbitageRecordShow = action.payload
        },
        setArbitageSearchDraft: (state, action) => {
            state.arbitageSearchDraft = action.payload
        },
        //PAGINATION ARBITAGE BETTING//

        //V2 SYNDICATE BETTING//
        setSyndicateBettingV2: (state, action) => {
            state.syndicateBettingV2 = action.payload
        },
        setSyndicateV2PageOneVal: (state, action) => {
            state.syndicateV2PageOneVal = action.payload
        },
        setSyndicateV2PageSecondVal: (state, action) => {
            state.syndicateV2PageSecondVal = action.payload
        },
        setSyndicateV2IsVisible: (state, action) => {
            state.syndicateV2IsVisible = action.payload
        },
        setSyndicateV2ShowRecord: (state, action) => {
            state.syndicateV2ShowRecord = action.payload
        },
        setSyndicateV2Payload: (state, action) => {
            state.syndicateV2Payload = action.payload
        },
        setSyndicateV2Data: (state, action) => {
            state.syndicateV2Data = action.payload
        },
        setIsV2Loading: (state, action) => {
            state.isV2Loading = action.payload
        },
        //V2 SYNDICATE BETTING//

        //SYNDICATE COMBINATIONS//
        setSyndicateCombinations: (state, action) => {
            state.syndicateCombinations = action.payload
        },
        setCombinationsPageOneVal: (state, action) => {
            state.combinationsPageOneVal = action.payload
        },
        setCombinationsPageSecondVal: (state, action) => {
            state.combinationsPageSecondVal = action.payload
        },
        setCombinationsIsVisible: (state, action) => {
            state.combinationsIsVisible = action.payload
        },
        setCombinationsShowRecord: (state, action) => {
            state.combinationsShowRecord = action.payload
        },
        //SYNDICATE COMBINATIONS//

        //SYNDICATE USER ANALYSIS//
        setSyndicateUserAnalysis: (state, action) => {
            state.syndicateUserAnalysis = action.payload
        },
        setSyndicateUserAnalysisOpen: (state, action) => {
            state.syndicateUserAnalysisOpen = action.payload
        },
        setIsAnalysisLoading: (state, action) => {
            state.isAnalysisLoading = action.payload
        },
        //SYNDICATE USER ANALYSIS//

        //LATE BETS//
        setLateBets: (state, action) => {
            state.lateBets = action.payload
        },
        setLateBetsPageOneVal: (state, action) => {
            state.lateBetsPageOneVal = action.payload
        },
        setLateBetsPageSecondVal: (state, action) => {
            state.lateBetsPageSecondVal = action.payload
        },
        setLateBetsIsVisible: (state, action) => {
            state.lateBetsIsVisible = action.payload
        },
        setLateBetsShowRecord: (state, action) => {
            state.lateBetsShowRecord = action.payload
        },
        setIsLateBetsLoading: (state, action) => {
            state.isLateBetsLoading = action.payload
        },
        //LATE BETS//
    },
});

export const {
    setSameIps,
    setSameIpUsers,
    setFraudIpMacAdress,
    setFraudIpMacByUsers,
    setSyndicateBetting,
    setPlayerBets,
    setArbitageData,
    setDupeCids,
    setIsPrevUserRespDupeCids,
    setdisableBtnRiskMgt,
    setUserSameIpVisible,


    //PAGINATION USER WITH SAMEIP//
    setPaginationFirstValSameIp,
    setPaginationSecondValSameIp,
    setSameIpIsVisible,
    setSameIpRecordShow,
    setUserPageOneValue,
    setUserPageSecondValue,
    setUserIsVisible,
    setUserRecordShow,
    setOpenDialouge,
    setIsUserIpVisible,
    setUserIpData,
    setPrevPayload,
    //PAGINATION USER WITH SAMEIP//

    //PAGINATION USER WITH SAME MACIP//
    setFraudMacIpPageOneValue,
    setFraudMacIpPageSecondValue,
    setFraudMacIpIsvisible,
    setFraudMacIpRecordShow,
    setUserMacIpPageOneValue,
    setUserMacIpSecondValue,
    setUserMacIpIsVisible,
    setUserMacIpShowRecord,
    //PAGINATION USER WITH SAME MACIP//

    //PAGINATION SYNDICATE BETTING//
    setSyndicatePageOneVal,
    setSyndicatePageSecondVal,
    setSyndicateIsVisible,
    setSyndicateShowRecord,
    setUserSyndicatePageOneVal,
    setUserSyndicateSecondVal,
    setUserSyndicateIsVisible,
    setUserSyndictaeShowRecord,
    setSyndicateData,
    setSyndicatePayload,
    setIsUserLoading,
    //PAGINATION SYNDICATE BETTING//

    //PAGINATION ARBITAGE BETTING//
    setArbitagePageOneValue,
    setArbitageSecondValue,
    setArbitageIsVisible,
    setArbitageShowRecord,
    setArbitageSearchDraft,
    //PAGINATION ARBITAGE BETTING//

    //V2 SYNDICATE BETTING//
    setSyndicateBettingV2,
    setSyndicateV2PageOneVal,
    setSyndicateV2PageSecondVal,
    setSyndicateV2IsVisible,
    setSyndicateV2ShowRecord,
    setSyndicateV2Payload,
    setSyndicateV2Data,
    setIsV2Loading,
    //V2 SYNDICATE BETTING//

    //SYNDICATE COMBINATIONS//
    setSyndicateCombinations,
    setCombinationsPageOneVal,
    setCombinationsPageSecondVal,
    setCombinationsIsVisible,
    setCombinationsShowRecord,
    //SYNDICATE COMBINATIONS//

    //SYNDICATE USER ANALYSIS//
    setSyndicateUserAnalysis,
    setSyndicateUserAnalysisOpen,
    setIsAnalysisLoading,
    //SYNDICATE USER ANALYSIS//

    //LATE BETS//
    setLateBets,
    setLateBetsPageOneVal,
    setLateBetsPageSecondVal,
    setLateBetsIsVisible,
    setLateBetsShowRecord,
    setIsLateBetsLoading,
    //LATE BETS//

} = riskManagementSlice.actions;

export const getFraudScrubIPs = (pageNum, itemsPerPage, userName, params) => (dispatch) => {
    const payload = {
        // userName: params.userName,
        createdToDate: params.createdToDate,
        createdFromDate: params.createdFromDate
    }
    let url = userName ? riskManagement.getFraudScrubIPs + `?userName=${userName}&pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}` : riskManagement.getFraudScrubIPs + `?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`
    apiCaller(url, "POST", payload).then((res) => {
        dispatch(setSameIps(res.data));
        dispatch(setIsPrevUserRespDupeCids(userName))
        dispatch(setdisableBtnRiskMgt(true))
        dispatch(setUserSameIpVisible(true))
        dispatch(setIsUserIpVisible(true))
        if (res.data.data.length === 0) {
            toaster.success(messageEnhancer(res.msg));
        }

    }).catch((err) => {
        toaster.error(messageEnhancer(err.response));
        // const isResponse = err.response === "NO_FRAUD_IP_TO_LIST" ? userName : false;
        dispatch(setIsPrevUserRespDupeCids(""));
        dispatch(setdisableBtnRiskMgt(true))

    }
    )
}

export const getFraudIpUsers = (ip, pageNum, itemsPerPage) => (dispatch) => {
    let url = riskManagement.getFraudScrubUsersByIP(ip, pageNum, itemsPerPage)
    apiCaller(url, "GET", {}).then((res) => {
        if (res.status === 200) {
            dispatch(setSameIpUsers(res.data))
        }
    }).catch(() => { })
}
export const getFraudIPAndMacAddress = (pageNum, itemsPerPage) => (dispatch) => {
    let url = riskManagement.getFraudIPAndMacAddress(pageNum, itemsPerPage)
    apiCaller(url, "POST").then((res) => {
        if (res.status === 200) {
            dispatch(setFraudIpMacAdress(res.data))
        }
    }).catch(() => { })
}

export const getFraudIPAndMacByUsers = (ip, macAddress, pageNum, itemsPerPage) => (dispatch) => {
    let url = riskManagement.getUsersByIPAndMacAddress(pageNum, itemsPerPage)
    const obj = {
        ip: ip,
        macAddress: macAddress
    }
    apiCaller(url, "POST", obj).then((res) => {
        if (res.status === 200) {
            dispatch(setFraudIpMacByUsers(res.data))
        }
    })
}

export const getSyndicateBettings = (pageNum, itemsPerPage, params) => (dispatch) => {
    // let url = userName ? riskManagement.getSyndicateBetting + `?userName=${userName}&pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}` : riskManagement.getSyndicateBetting + `?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`
    let url = riskManagement.getSyndicateBetting + `?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`;
    const payload = {
        createdToDate: params.createdToDate,
        createdFromDate: params.createdFromDate,
        userName: params.userName,
    }
    apiCaller(url, "POST", payload).then((res) => {
        if (res.status === 200) {
            dispatch(setSyndicateBetting(res.data))
            // dispatch(setIsPrevUserRespDupeCids(userName))
            dispatch(setdisableBtnRiskMgt(true))
            dispatch(setIsUserLoading(true))
            if (res.data.data.length === 0) {
                toaster.success(messageEnhancer(res.msg));
            }
        }
    }).catch((err) => {
        dispatch(setIsPrevUserRespDupeCids(""))
        dispatch(setdisableBtnRiskMgt(true))
    }
    )
}

export const getPlayerbets = (selectionId, selectionName, eventName, stake, pageNum, itemsPerPage) => (dispatch) => {
    let url = riskManagement.getPlayerbets(selectionId, eventName, stake, pageNum, itemsPerPage)
    apiCaller(url, "GET").then((res) => {
        if (res.status === 200) {
            dispatch(setPlayerBets(res.data))
        }
    })
}
export const getArbitageBet = (pageNum, itemsPerPage, param) => (dispatch) => {
    let url = riskManagement.arbitageBet(pageNum, itemsPerPage)
    apiCaller(url, "POST", param).then((res) => {
        if (res.status === 200) {
            dispatch(setArbitageData(res.data[0]));
            dispatch(setIsPrevUserRespDupeCids(param))
            dispatch(setdisableBtnRiskMgt(true))
        }
    }).catch((err) => {
        toaster.error(messageEnhancer(err.response))
        dispatch(setIsPrevUserRespDupeCids(""))
        dispatch(setdisableBtnRiskMgt(true))
    }
    )
}

export const getDupeCids = (countryCode, email, firstName, lastName, phnNumber) => (dispatch) => {
    let url = riskManagement.dupeCids
    const obj = {
        countryCode: countryCode,
        email: email,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phnNumber
    }
    apiCaller(url, "POST", obj).then((res) => {
        if (res.status === 200) {
            dispatch(setDupeCids(res.data))
        }
    }).catch(() => { })
}

export const getSyndicateBettingsV2 = (pageNum, itemsPerPage, params) => (dispatch) => {
    dispatch(setIsV2Loading(true))
    let url = riskManagement.syndicateBettingV2 + `?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`
    apiCaller(url, "POST", params).then((res) => {
        if (res.status === 200) {
            dispatch(setSyndicateBettingV2(res.data))
            dispatch(setdisableBtnRiskMgt(true))
            dispatch(setIsV2Loading(false))
            if (res.data && res.data.data && res.data.data.length === 0) {
                toaster.success(messageEnhancer(res.msg))
            }
        }
    }).catch((err) => {
        dispatch(setdisableBtnRiskMgt(true))
        dispatch(setIsV2Loading(false))
        toaster.error(riskErrorText(err))
    })
}

// The row stake is the group AVERAGE, so the search tolerance is sent and the
// API re-applies that band - INT-11556.
export const getSyndicateV2PlayerBets =
    (selectionId, fixtureName, stake, stakeTolerance, pageNum, itemsPerPage) => (dispatch) => {
        dispatch(setIsUserLoading(true))
        let url = riskManagement.syndicateV2PlayerBets(selectionId) +
            `?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}&stake=${encodeURIComponent(stake ?? 0)}`
        if (fixtureName) url += `&fixtureName=${encodeURIComponent(fixtureName)}`
        if (stakeTolerance !== null && stakeTolerance !== undefined && stakeTolerance !== '') {
            url += `&stakeTolerance=${encodeURIComponent(stakeTolerance)}`
        }
        apiCaller(url, "GET").then((res) => {
            if (res.status === 200) {
                dispatch(setPlayerBets(res.data))
            }
            dispatch(setIsUserLoading(false))
        }).catch((err) => {
            dispatch(setIsUserLoading(false))
            toaster.error(riskErrorText(err))
        })
    }

export const getSyndicateCombinations = (minOccurrences, pageNum, itemsPerPage) => (dispatch) => {
    dispatch(setCombinationsIsVisible(false))
    let url = riskManagement.syndicateCombinations + `?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`
    if (minOccurrences) url += `&minOccurrences=${minOccurrences}`
    apiCaller(url, "GET").then((res) => {
        if (res.status === 200) {
            dispatch(setSyndicateCombinations(res.data))
            dispatch(setCombinationsIsVisible(true))
            if (res.data && res.data.data && res.data.data.length === 0) {
                toaster.success(messageEnhancer(res.msg))
            }
        }
    }).catch((err) => {
        dispatch(setCombinationsIsVisible(true))
        toaster.error(riskErrorText(err))
    })
}

export const getSyndicateUserAnalysis = (userId) => (dispatch) => {
    dispatch(setIsAnalysisLoading(true))
    let url = riskManagement.syndicateUserAnalysis(userId)
    apiCaller(url, "GET").then((res) => {
        if (res.status === 200) {
            dispatch(setSyndicateUserAnalysis(res.data))
            dispatch(setIsAnalysisLoading(false))
        }
    }).catch((err) => {
        toaster.error(riskErrorText(err))
        dispatch(setIsAnalysisLoading(false))
    })
}

export const flagSyndicatePattern = (patternId, minOccurrences, pageNum, itemsPerPage) => (dispatch) => {
    let url = riskManagement.flagSyndicatePattern(patternId)
    apiCaller(url, "POST").then((res) => {
        if (res.status === 200) {
            toaster.success("Pattern flagged successfully")
            dispatch(getSyndicateCombinations(minOccurrences || null, pageNum || 0, itemsPerPage || 25))
        }
    }).catch((err) => {
        toaster.error(riskErrorText(err))
    })
}

export const getLateBets = (windowDays, minutesBeforeKickoff, pageNum, itemsPerPage, fromDate, toDate) => (dispatch) => {
    dispatch(setIsLateBetsLoading(true))
    let url = riskManagement.lateBets + `?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`
    if (windowDays) url += `&windowDays=${windowDays}`
    if (minutesBeforeKickoff) url += `&minutesBeforeKickoff=${minutesBeforeKickoff}`
    if (fromDate) url += `&fromDate=${encodeURIComponent(fromDate)}`
    if (toDate) url += `&toDate=${encodeURIComponent(toDate)}`
    apiCaller(url, "GET").then((res) => {
        if (res.status === 200) {
            dispatch(setLateBets(res.data))
            dispatch(setIsLateBetsLoading(false))
            if (res.data && res.data.data && res.data.data.length === 0) {
                toaster.success(messageEnhancer(res.msg))
            }
        }
    }).catch((err) => {
        dispatch(setIsLateBetsLoading(false))
        toaster.error(riskErrorText(err))
    })
}

export default riskManagementSlice.reducer;